import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";
// import { BankIDInputMeta, CorporateNameInputMeta } from '@Modules/admin/basicSettings/containers/formHandlers/common.meta';

export interface IParametersFormMeta {
    regionValue: FormInputMeta;
    regionLabel: FormInputMeta;
    domain: FormInputMeta;  
    currencyAmount: FormInputMeta;
    currency: FormInputMeta;
    hpxAccount: FormInputMeta;
    bankAccount: FormInputMeta;
    accountBalance: FormInputMeta;
    idBuyer: FormInputMeta;
    idBuyerBusiness: FormInputMeta;
    iCA: FormInputMeta;
    idProcessor: FormInputMeta;
    schema: any;
  }

const ParametersFormMeta = {} as IParametersFormMeta;

ParametersFormMeta.regionValue = {
    name: "regionValue",
    label: "",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.regionLabel = {
    label: '',
    name: 'regionLabel',
    type: 'select',
    placeholder: 'Select ...',
    options:  [
        {value: '1', label: 'A'},
        {value: '2', label: 'B'},
        {value: '3', label: 'C'},
        {value: '4', label: 'D'},
        {value: '5', label: 'E'}
    ],
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.domain = {
    name: 'domain',
    label: 'Domaine',    
    type: 'select',
    placeholder: 'Select ...',
    options:  [
        {value: '1', label: 'Worldwide'},
        {value: '2', label: 'domain 1'},
        {value: '3', label: 'domain 2'},
    ],
    validation: yup.string().required("Ce champ est requis"),
}

ParametersFormMeta.currencyAmount = {
    name: "currencyAmount",
    label: "",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.currency = {
    name: 'currency',
    label: '',    
    type: 'select',
    placeholder: 'Select ...',
    options:  [
        {value: '1', label: 'CFA Franc BEAC'},
        {value: '2', label: 'Devise 2'},
        {value: '3', label: 'Devise 3'},
        {value: '4', label: 'Devise 4'},
        {value: '5', label: 'Devise 5'}
    ],
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.hpxAccount = {
    name: "hpxAccount",
    label: "Compte HPX",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.bankAccount = {
    name: "bankAccount",
    label: "Compte Banque",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.accountBalance = {
    name: "accountBalance",
    label: "Solde Compte",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}

// *****************************
ParametersFormMeta.iCA = {
    name: "iCA",
    label: "ICA",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.idBuyer = {
    name: "idBuyer",
    label: "ID Acquéreur",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.idBuyerBusiness = {
    name: "idBuyerBusiness",
    label: "ID Affaire Acquéreur",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
ParametersFormMeta.idProcessor = {
    name: "idProcessor",
    label: "ID Processeur",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
// *****************************

ParametersFormMeta.schema = yup.object().shape(getValidationSchema(ParametersFormMeta));

export default ParametersFormMeta;